import { Injectable, inject } from '@angular/core';

import { NavController } from '@ionic/angular/standalone';
import { map, of, switchMap } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SettingsService } from 'src/app/services/settings.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingNotCompletedGuard {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly navController = inject(NavController);
  private readonly settingsService = inject(SettingsService);

  public canActivate(): Observable<boolean> {
    return this.authenticationService.msalInteractionNone$.pipe(
      switchMap(() => {
        if (!this.authenticationService.isLoggedIn()) {
          return of(false);
        }

        return this.settingsService.isOnboardingCompleted$.pipe(
          map((isOnboardingCompleted) => {
            if (!isOnboardingCompleted) {
              return true;
            }
            this.navController.navigateForward('/home', {
              animated: false,
              replaceUrl: true,
            });
            return false;
          }),
        );
      }),
    );
  }
}
